import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-asp-request-existspopup',
  templateUrl: './asp-request-existspopup.component.html',
  styleUrls: ['./asp-request-existspopup.component.scss']
})
export class AspRequestExistspopupComponent {

  // Controls visibility from the parent
  @Input() isOpen: boolean = false;

  // Same shape as `existingRequest` in asp-instant-request.component.ts
  // e.g. { requestId, response: { body: { spareRequest, spareRequestItemList } } }
  @Input() existingRequest: any = null;

  // Vehicle info for the "Car: ..." line
  @Input() vehicleData: any = null;

  // Registration number shown in the header
  @Input() regNo: string = '';

  // Emitted when the close (X) icon or backdrop is clicked
  @Output() closePopup = new EventEmitter<void>();

  // Emitted when "Start a Fresh Request" is clicked — parent decides what that means
  @Output() startFresh = new EventEmitter<void>();

  // Emitted when "Add Items to Existing" is clicked — parent calls its own update-request API
  @Output() addToExisting = new EventEmitter<void>();

  showFullItems: boolean = false;

  get existingRequestItems() {
    return this.existingRequest?.response?.body?.spareRequestItemList || [];
  }

  getVisibleItems(items: any[]) {
    return this.showFullItems ? items : items.slice(0, 3);
  }

  toggleFullItems() {
    this.showFullItems = !this.showFullItems;
  }

  hasMoreItems(): boolean {
    return this.existingRequestItems.length > 3;
  }

  getOverallStatus(items: any[]): string {
    if (!items || items.length === 0) return '⏳ Requested';

    // Priority order: Order Created > Quote Approved > Quote Received > Requested
    const priorityOrder = ['4', '10', '9', '8', '1'];
    const statusSet = items.map(i => i.status.toString());

    for (const status of priorityOrder) {
      if (statusSet.includes(status)) {
        switch (status) {
          case '4':
          case '10':
            return '📦 Order Created';
          case '9':
            return '✅ Quote Approved';
          case '8':
            return '💬 Quote Received';
          case '1':
            return '⏳ Requested';
        }
      }
    }
    return '⏳ Requested';
  }

  getCreatedDate(gmtDate: string | null | undefined): string {
    if (!gmtDate || gmtDate === 'NA') {
      return 'NA';
    }
    // Treat backend time as UTC, then render in IST
    const utcDate = new Date(gmtDate + ' UTC');
    const options: Intl.DateTimeFormatOptions = {
      day: '2-digit', month: 'short', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: true,
      timeZone: 'Asia/Kolkata'
    };
    return utcDate.toLocaleString('en-IN', options);
  }

  onClose(): void {
    this.closePopup.emit();
  }

  onStartFresh(): void {
    this.startFresh.emit();
  }

  onAddToExisting(): void {
    this.addToExisting.emit();
  }
  
}